import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { headersConfig, basicAuthConfig } from "../../../config/constants";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import menuBurger from "../../../assets/img/lp/studiobrahma-logo-big.svg";

const LeadsDataTable = () => {
  const navigate = useNavigate();


  useEffect(() => {
    const loggedIn = sessionStorage.getItem("lpLeadsLoggedIn");
    if (!loggedIn) {
      navigate("/campaign/lp-leads-login");
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem("lpLeadsLoggedIn");
    navigate("/campaign/lp-leads-login");
  };


  const [leads, setLeads] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ name: "", email: "", date: "" });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [nextHit, setNextHit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);


  const fetchLeads = async (pageNo = 1, pageLimit = 10) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.slice.ooo/main/slice/api/v1/user/marketing-leads?pageNo=${pageNo}&limit=${pageLimit}`,
        {
          headers: {
            ...headersConfig,
            ...basicAuthConfig,
          },
        }
      );

      const apiData = response?.data?.data || {};
      const data = apiData?.data || [];
      const total = apiData?.total || 0;
      const next = apiData?.nextHit || null;
      const totalPg = apiData?.totalPage || 0;

      setLeads(data);
      setTotalRows(total);
      setNextHit(next);
      setTotalPages(totalPg);
    } catch (error) {
      console.error("❌ Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads(page, limit);
  }, [page, limit]);


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };


  const filteredLeads = leads.filter((lead) => {
    const fullName = `${lead.firstName || ""} ${lead.lastName || ""}`.toLowerCase();
    const email = (lead.email || "").toLowerCase();
    const date = lead.createdAt || "";

    return (
      fullName.includes(filters.name.toLowerCase()) &&
      email.includes(filters.email.toLowerCase()) &&
      (filters.date ? date.startsWith(filters.date) : true)
    );
  });


  const columns = [
    {
      name: "Name",
      selector: (row) => `${row.firstName} ${row.lastName}`,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Signed Up",
      selector: (row) => (row.isSignedUp ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.createdAt).toLocaleString(),
      sortable: true,
    },
  ];



const exportToExcel = async () => {
  try {
    setLoading(true);

    let allLeads = [];
    let pageNo = 1;
    let hasNext = true;

    while (hasNext) {
      const response = await axios.get(
        `https://api.slice.ooo/main/slice/api/v1/user/marketing-leads?pageNo=${pageNo}&limit=${limit}`,
        {
          headers: {
            ...headersConfig,
            ...basicAuthConfig,
          },
        }
      );

      const apiData = response?.data?.data || {};
      const pageLeads = apiData?.data || [];
      const nextHit = apiData?.nextHit;

      allLeads = [...allLeads, ...pageLeads];

      if (nextHit && nextHit !== pageNo) {
        pageNo = nextHit; 
      } else {
        hasNext = false;
      }
    }


    const exportData = allLeads.map((lead) => ({
      Name: `${lead.firstName} ${lead.lastName}`,
      Email: lead.email,
      "Signed Up": lead.isSignedUp ? "Yes" : "No",
      "Created At": new Date(lead.createdAt).toLocaleString(),
    }));


    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Leads");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const file = new Blob([buf], { type: "application/octet-stream" });
    saveAs(file, `Marketing_Leads_All_${new Date().toISOString().slice(0, 10)}.xlsx`);

  } catch (error) {

  } finally {
    setLoading(false);
  }
};



  const handleNextPage = () => {
    if (nextHit) {
      setPage(nextHit);
      fetchLeads(nextHit, limit);
    }
  };

  const handlePrevPage = () => {
    if (page > 1) {
      const prev = page - 1;
      setPage(prev);
      fetchLeads(prev, limit);
    }
  };

  return (
    <div style={{ padding: "20px" }}>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2>
          <img src={menuBurger} alt="mobile-menu" height={40} /> | Lead Dashboard - Slice
        </h2>
        <div>
          <button
            onClick={exportToExcel}
            style={{
              padding: "8px 15px",
              background: "green",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Export to Excel
          </button>
          <button
            onClick={handleLogout}
            style={{
              padding: "8px 15px",
              background: "#dc3545",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      </div>


      <div style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
        <input
          type="text"
          name="name"
          placeholder="Search by Name"
          value={filters.name}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="email"
          placeholder="Search by Email"
          value={filters.email}
          onChange={handleFilterChange}
        />
        <input
          type="date"
          name="date"
          value={filters.date}
          onChange={handleFilterChange}
        />
      </div>


      <DataTable
        columns={columns}
        data={filteredLeads}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={(newLimit) => {
          setLimit(newLimit);
          fetchLeads(1, newLimit);
        }}
        highlightOnHover
        pointerOnHover
        responsive
      />


      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <button
          onClick={handlePrevPage}
          disabled={page <= 1}
          style={{
            padding: "6px 12px",
            marginRight: "10px",
            background: page <= 1 ? "#ccc" : "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: page <= 1 ? "pointer" : "pointer",
          }}
        >
          Prev
        </button>

        <span>
          Page <strong>{page}</strong> {totalPages ? `of ${totalPages}` : ""}
        </span>

        <button
          onClick={handleNextPage}
          disabled={!nextHit}
          style={{
            padding: "6px 12px",
            marginLeft: "10px",
            background: !nextHit ? "#ccc" : "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: !nextHit ? "pointer" : "pointer",
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LeadsDataTable;
